import React from 'react';

import { breakpoints } from '@src/common/breakpoints';
import useMediaQuery from '@src/hooks/useMediaQuery';

import { CheckoutCompactSidebar } from './CheckoutCompactSidebar';
import { CheckoutPageOutlet } from './CheckoutPageOutlet';
import { CheckoutSidebarSkeleton } from './CheckoutSkeleton';
import type { CheckoutMode } from './types';
import { resolveStepChrome } from './utils';
import { CheckoutHeader } from './CheckoutHeader';
import { CheckoutPageShell, LayoutRoot, MainColumn, SidebarColumn } from './styles';

type CheckoutLayoutProps = {
  mode: CheckoutMode;
  sidebar?: React.ReactNode;
  useRouting?: boolean;
  initialMode?: CheckoutMode;
  bootstrapping?: boolean;
};

export const CheckoutLayout = (props: CheckoutLayoutProps) => {
  const { mode, sidebar = null, useRouting = false, initialMode, bootstrapping = false } = props;
  const isCompactSidebar = useMediaQuery(breakpoints.smallTablet);
  const { showsSidebar, showsHeader } = resolveStepChrome(mode, bootstrapping);

  const SidebarComponent = isCompactSidebar ? CheckoutCompactSidebar : SidebarColumn;
  const sidebarComponentProps = isCompactSidebar ? {} : { 'data-testid': 'checkout-sidebar-column' };

  return (
    <CheckoutPageShell data-testid='checkout-page'>
      {showsHeader ? <CheckoutHeader /> : null}

      <LayoutRoot data-testid='checkout-layout'>
        <MainColumn data-testid='checkout-main-column' data-full={String(!showsSidebar)}>
          <CheckoutPageOutlet
            mode={mode}
            useRouting={useRouting}
            initialMode={initialMode}
            bootstrapping={bootstrapping}
          />
        </MainColumn>

        {showsSidebar ? (
          <SidebarComponent {...sidebarComponentProps}>
            {bootstrapping ? <CheckoutSidebarSkeleton /> : sidebar}
          </SidebarComponent>
        ) : null}
      </LayoutRoot>
    </CheckoutPageShell>
  );
};

export default CheckoutLayout;
